<template>
    <cs-card>
        <template #header>
            <div class="cs-card__icon">
                <mdi-icon icon="mdiImageOutline" />
            </div>

            <div class="cs-card__title">
                Photo
            </div>
        </template>

        <div>
            <div
                v-if="loading || photoSrc"
                class="flex justify-center items-center"
            >
                <img
                    v-if="loading"
                    src="/img/loader-761.svg"
                    alt="Loading..."
                />

                <img
                    v-else
                    :src="photoSrc"
                    alt=""
                    width="215"
                    height="215"
                />
            </div>

            <div v-else class="cs-card__no-content">
                There is no photo for this article.
            </div>
        </div>
    </cs-card>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import axios from '@/axios';
import CsCard from '@/components/CsCard.vue';

const props = defineProps({
    article:
    {
        type:     Object,
        required: true,
    },
});

const loading = ref(false);
const photoSrc = ref('');

const photoId = computed(() => props.article.photo_id || 0);

function fetchPhoto()
{
    return new Promise((resolve, reject) =>
    {
        if(loading.value)
        {
            return;
        }

        if(photoId.value === 0)
        {
            reject(`no photo ID for article ${props.article.code}`);
            return;
        }

        loading.value = true;

        const url = '/api/photo/{id}'
            .replace('{id}', props.article.photo_id);
        axios.get(url)
            .then(({ data }) =>
            {
                photoSrc.value = `data:image/jpeg;base64,${data}`;
                resolve(photoSrc.value);
            })
            .catch(error =>
            {
                // todo: handle error
                reject(error);
            })
            .then(() =>
            {
                loading.value = false;
            });

    });
}

onMounted(async() =>
{
    if(photoId.value === 0)
    {
        return;
    }

    await fetchPhoto();
});
</script>
